import {Scan} from "@/types/Scan";

export const QRJsonRequest = async (url: string, authToken: string, locale: string) => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`,
        "X-Language": locale || "it"
      },
    }
    const jsonFetch = await fetch(url, init)
    return await jsonFetch.json() as Array<Scan>

  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
